import React, { useState, useEffect } from "react";
import { useNavigate, Link,useLocation} from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import { FaBook, FaPlus, FaBars, FaTimes, FaCog } from 'react-icons/fa'; // Import the book, plus, bars, and times icons
import { FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Tabs,
  Tab,
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel
} from "@mui/material";
import { useIsMobile } from './hooks/isMobile';
import './styles/IncidentDetail.css';
import Cookies from 'js-cookie';
import ReportIncidentForm from "./ReportIncidentForm";


const Auth = () => {
  const [activeTab, setActiveTab] = useState("login");
  const [email, setEmail] = useState(""); // Only for register
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const isMobile = useIsMobile(); // Use the useIsMobile hook
  const [isNavOpen, setIsNavOpen] = useState(false); // State to manage the mobile nav menu
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userDetails, setUserDetails] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success"); // "success" or "error"
  const location = useLocation();
  const [selectedAvatar, setSelectedAvatar] = useState("");
  const [race, setRace] = useState("");
  const [gender, setGender] = useState("");
  const [religion, setReligion] = useState("");
  const[hasDisability, setHasDisability] = useState("");
  const [disability_type, setDisabilityType] = useState("");
const [neurologicalDisabilityType, setNeurologicalDisabilityType] = useState("");
const [physicalDisabilityType, setPhysicalDisabilityType] = useState("");
const [sensoryDisabilityType, setSensoryDisabilityType] = useState("");
const [intellectualDisabilityType, setIntellectualDisabilityType] = useState("");
const [mentalHealthConditionType, setMentalHealthConditionType] = useState("");
const [disability, setDisability] = useState("");
const [selectedDisability, setSelectedDisability] = useState("");
const [selectedDisabilityType, setSelectedDisabilityType] = useState("");
  const [sexual_orientation, setSexualOrientation] = useState("");
const [avatars, setAvatars] = useState([
  "black_man_.png",
  "memo_11.png",
  "memo_17.png",
  "memo_25.png",
  "memo_26.png",
  "memo_28.png",
  "memo_4.png",
  "memo_6.png",
  "purple_lady.png",
  "vibrent_10.png",
  "vibrent_11.png",
  "vibrent_12.png",
  "vibrent_13.png",
  "vibrent_14.png",
  "vibrent_2.png",
  "vibrent_3.png",
  "vibrent_4.png",
  "vibrent_5.png",
  "vibrent_6.png",
  "vibrent_7.png",
  "vibrent_8.png",
  "vibrent_21.png",

]);
const ethnicityOptions = [
  'African/African American/Black',
  'Arab/Middle Eastern',
  'Asian/Asian American',
  'Caucasian/White',
  'Hispanic/Latino/Latina/Latinx',
  'Indigenous/Native American/Alaska Native',
  'Native Hawaiian/Pacific Islander',
  'Mixed/Multiple ethnicities',
  'Other',
  'Prefer not to say'
];
const genderOptions = [
  'Woman',
  'Man',
  'Non-binary',
  'Transgender woman',
  'Transgender man',
  'Genderqueer',
  'Genderfluid',
  'Agender',
  'Other',
  'Prefer not to say'
];
const religionOptions = [
  'Agnosticism',
  'Atheism',
  'Baha\'i Faith',
  'Buddhism',
  'Christianity',
  'Hinduism',
  'Islam',
  'Jainism',
  'Judaism',
  'Paganism',
  'Secular Humanism',
  'Shinto',
  'Sikhism',
  'Spiritual but not religious',
  'Taoism',
  'Traditional Indigenous/Native Faith',
  'Unitarian Universalism',
  'Zoroastrianism',
  'Other',
  'Prefer not to say'
];

const sexualOrientationOptions = [
  'Heterosexual/Straight',
  'Gay',
  'Lesbian',
  'Bisexual',
  'Pansexual',
  'Asexual',
  'Demisexual',
  'Queer',
  'Questioning',
  'Fluid',
  'Omnisexual',
  'Graysexual',
  'Aromantic',
  'Other',
  'Prefer not to say'
];

const neurologicalDisabilityOptions = [
  'Epilepsy',
  'Multiple sclerosis',
  'Parkinson\'s disease',
  'Cerebral palsy',
  'Traumatic brain injury',
  'Stroke-related disability',
  'Migraine disorder',
  'Spinal cord injury',
  'Huntington\'s disease',
  'Other neurological disability',
  'Prefer not to say'
];

const intellectualDisabilityOptions = [
  'Down syndrome',
  'Fragile X syndrome',
  'Developmental delay',
  'Fetal alcohol spectrum disorder',
  'Intellectual disability - mild',
  'Intellectual disability - moderate',
  'Intellectual disability - severe',
  'Other intellectual disability',
  'Prefer not to say'
];

const mentalHealthConditionOptions = [
  'Anxiety disorder',
  'Depression',
  'Bipolar disorder',
  'Post-traumatic stress disorder (PTSD)',
  'Obsessive-compulsive disorder (OCD)',
  'Schizophrenia',
  'Eating disorder',
  'Personality disorder',
  'Substance use disorder',
  'Other mental health condition',
  'Prefer not to say'
];

const physicalDisabilityOptions = [
  'Muscular dystrophy',
  'Spina bifida',
  'Amputation',
  'Arthritis',
  'Chronic pain',
  'Cystic fibrosis',
  'Fibromyalgia',
  'Limited mobility',
  'Wheelchair user',
  'Dwarfism/short stature',
  'Other physical disability',
  'Prefer not to say'
];
const sensoryDisabilityOptions = [
  'Blindness',
  'Low vision',
  'Color blindness',
  'Deaf',
  'Hard of hearing',
  'Deaf-Blind',
  'Auditory processing disorder',
  'Visual processing disorder',
  'Other sensory disability',
  'Prefer not to say'
];
  
  const navigate = useNavigate();

  useEffect(() => {
    // Check for the `token` query parameter in the URL
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      // Run the confirmation API call
      const confirmAccount = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/auth/confirm?token=${token}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.ok) {
            setMessage("Your account has been confirmed! You can now log in.");
            setSeverity("success");
          } else {
            const errorData = await response.json();
            setMessage(errorData.message || "Failed to confirm account.");
            setSeverity("error");
          }
        } catch (error) {
          console.error("Error confirming account:", error);
          setMessage("An error occurred. Please try again.");
          setSeverity("error");
        } finally {
          setOpenSnackbar(true);
        }
      };

      confirmAccount();
    }
  }, [location]);


  const encodeCredentials = (username, password) => {
    return btoa(`${username}:${password}`);
  };

  
/** Handle Login Submission */
const handleLogin = async (e) => {
  e.preventDefault();
  setError("");

  try {
    // Step 1: Check if the user is confirmed AND get the full user data
    const userConfirmationResponse = await fetch(`${process.env.REACT_APP_API_URL}/auth/user/${username}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!userConfirmationResponse.ok) {
      const errorData = await userConfirmationResponse.json();
      setError(errorData.message || "Failed to verify user confirmation.");
      return;
    }

    const userData = await userConfirmationResponse.json();
    console.log("User data from step 1:", userData);

    // Extract userId from the user data
    const userId = userData.id || userData.userId || userData.user_id || userData._id;
    console.log("Extracted userId:", userId);

    if (!userId) {
      setError("Unable to get user information. Please contact support.");
      return;
    }

    // Check if confirmed
    if (!userData.confirmed) {
      setError("Your account is not confirmed. Please check your email to confirm your account.");
      return;
    }

    // Step 2: Proceed with login if confirmed
    const encodedCredentials = encodeCredentials(username, password);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Basic ${encodedCredentials}`,
      },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();

    if (response.ok) {
      console.log("Login successful:", data);
      
      // Set all cookies including the userId we got from step 1
      Cookies.set("accessToken", data.accessToken, { expires: 1 });
      Cookies.set("refreshToken", data.refreshToken, { expires: 7 });
      Cookies.set("username", username, { expires: 7 });
      Cookies.set("userId", userId, { expires: 7 }); // Use the userId from step 1
      
      // Also store in localStorage as backup
      localStorage.setItem("userId", userId);
      localStorage.setItem("username", username);
      
      console.log("Successfully set userId:", userId);

      setMessage("Login successful!");
      setSeverity("success");
      setOpenSnackbar(true);
      navigate("/moderation");

    } else {
      setError(data.message || "Invalid username or password.");
    }
  } catch (error) {
    console.error("Error during login:", error);
    setError("An error occurred. Please try again.");
  }
};

  /** Handle Register Submission */
  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          email, 
          username, 
          password, 
          race,
          gender,
          sexual_orientation,
          disability,
          disability_type,
          religion,
          avatar_url: `https://my-image-bucket-the-green-book.s3.us-east-1.amazonaws.com/avatars/avatars/${selectedAvatar}` || null // Send the selected avatar or null 
          }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("A confirmation email has been sent to your email address.");
        setSeverity("success");
        setOpenSnackbar(true);
        
      } else {
        setError(data.error || "Registration failed");
      }
      
    } catch (err) {
      setError("Registration failed. Please try again.");
    }
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
    return emailRegex.test(email);
  };
  const handleLogout = async () => {
              try {
                  const refreshToken = Cookies.get("refreshToken");
      
                  const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
                      method: "POST",
                      headers: {
                          "Content-Type": "application/json",
                      },
                      body: JSON.stringify({ refreshToken }),
                  });
      
                  if (response.ok) {
                      Cookies.remove("accessToken");
                      Cookies.remove("refreshToken");
                      Cookies.remove("userId"); // Add this line
                      Cookies.remove("username");
                      setIsLoggedIn(false);
                      setUserDetails('');
                      navigate("/auth");
                  } else {
                      navigate("/auth");
                  }
              } catch (err) {
                  console.error("Logout error:", err);
              }
          };
  const checkAuthAndNavigate = (path) => {
          const token = Cookies.get("accessToken");
          if (!token) {
              navigate("/auth"); // Redirect to auth if no token
          } else {
              navigate(path); // Navigate to the intended path
          }
      };

  return (
    <div className="bg-gray-100 min-h-screen">
      
      <nav className="bg-white shadow-md p-4 mb-0">
                <div className="container mx-auto flex justify-between items-center">
                 <Link to="/home" className="text-xl font-bold text-color-blue-800 flex items-center">
                    SafeSpace
                    <img 
                        src="https://my-image-bucket-the-green-book.s3.us-east-1.amazonaws.com/logos/IconOnly_Transparent_NoBuffer.png"
                        alt="SafeSpace Logo" 
                        className="h-6 w-auto ml-6" 
                    />
                  </Link>
                          
                   </div>
            </nav>
            <div className={`flex flex-col items-center ${isMobile ? 'px-4 py-2 mt-2' : 'mt-16'} relative`}>

              {/* Bottom - Login/Register Form */}
              <Box
                sx={{
                  height: isMobile ? "80%" : "60%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#ffffff",
                  backgroundSize: "cover",
                  backgroundPosition: "left",
                  mt: 16, 
                }}
              >
                <Paper
                  elevation={3}
                  sx={{
                    width: "400px", // Fixed width for better spacing
                    padding: 4,
                    borderRadius: 2,
                    boxShadow: 3,
                  }}
                >
                  <Typography variant="h4" fontWeight="bold" mb={2}>
                    Welcome
                  </Typography>

                  {/* Tab Switcher - Styled to Look Like Buttons */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      backgroundColor: "#F4F4F4",
                      borderRadius: "8px",
                      mb: 3,
                      
                    }}
                  >
                    <Button
                      fullWidth
                      variant={activeTab === "login" ? "contained" : "text"}
                      sx={{
                        textTransform: "none",
                        backgroundColor: activeTab === "login" ? "#ffffff" : "transparent",
                        color: activeTab === "login" ? "#000" : "#999",
                        fontWeight: activeTab === "login" ? "bold" : "normal",
                      }}
                      onClick={() => setActiveTab("login")} 
                    >
                      Login
                    </Button>
                    <Button
                      fullWidth
                      variant={activeTab === "register" ? "contained" : "text"}
                      sx={{
                        textTransform: "none",
                        backgroundColor: activeTab === "register" ? "#ffffff" : "transparent",
                        color: activeTab === "register" ? "#000" : "#999",
                        fontWeight: activeTab === "register" ? "bold" : "normal",
                      }}
                      onClick={() => setActiveTab("register")}
                    >
                      Register
                    </Button>
                  </Box>

                  {/* Form Fields */}
                  <form onSubmit={activeTab === "login" ? handleLogin : handleRegister}>
                  {activeTab === "register" && (
                      <>
                        <TextField
                          fullWidth
                          label="Email"
                          variant="outlined"
                          margin="normal"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                       {validateEmail(email) && (

                        <FormControl fullWidth>
                        <InputLabel>Select ethnicity</InputLabel>
                        <Select
                          value={race}
                          label="Select ethnicity"
                          onChange={(e) => setRace(e.target.value)}
                          sx={{ mb: 2 }}
                        >
                          {ethnicityOptions.map((option) => (
                            <MenuItem 
                              key={option} 
                              value={option}
                              sx={{
                                whiteSpace: 'normal', // Allows text wrapping
                                py: 1.5 // More vertical padding
                              }}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                        </FormControl>

                        
                        )}

                      {/* Render gender selection only if race is selected */}
                      {race && (
                        <FormControl fullWidth>
                          <InputLabel>Select Gender</InputLabel>
                          <Select
                            value={gender}
                            label="Select Gender"
                            onChange={(e) => setGender(e.target.value)}
                            sx={{ mb: 2 }}
                          >
                            {genderOptions.map((option) => (
                              <MenuItem 
                                key={option} 
                                value={option}
                                sx={{
                                  whiteSpace: 'normal', // Allows text wrapping
                                  py: 1.5 // More vertical padding
                                }}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                       {gender && (
                          <FormControl fullWidth>
                          <InputLabel>Select Religion</InputLabel>
                          <Select
                            value={religion}
                            label="Select Religion"
                            onChange={(e) => setReligion(e.target.value)}
                            sx={{ mb: 2 }}
                          >
                            {religionOptions.map((option) => (
                              <MenuItem 
                                key={option} 
                                value={option}
                                sx={{
                                  whiteSpace: 'normal', // Allows text wrapping
                                  py: 1.5 // More vertical padding
                                }}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                          </FormControl>
                        
                        
                       )}
                      {religion && (

                              <Box sx={{ mt: 2 }}>
                              <Typography variant="subtitle1">Choose an avatar:</Typography>
                              <Box sx={{ display: 'flex', gap: 2, mt: 1, overflowX: 'auto', py: 2 }}>
                                {avatars.map((avatar) => (
                                  <Box
                                  key={avatar}
                                  onClick={() => setSelectedAvatar(avatar)}
                                  sx={{
                                    cursor: 'pointer',
                                    border: selectedAvatar === avatar ? '3px solid #1e3a8a' : '2px solid #e0e0e0',
                                    borderRadius: '50%',
                                    p: 1.5,  // Increased internal padding
                                    flexShrink: 0,
                                    width: 100,  // Container width (increased from 80)
                                    height: 100, // Container height (increased from 80)
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease', // Smooth hover effect
                                    '&:hover': {
                                      transform: 'scale(1.05)',
                                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                    }
                                  }}
                                >
                                    <img 
                                      src={`https://my-image-bucket-the-green-book.s3.us-east-1.amazonaws.com/avatars/avatars/${avatar}`} 
                                      alt="Avatar" 
                                      style={{ 
                                        width: '92%',  // Slightly smaller than container
                                        height: '92%', // Slightly smaller than container
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        display: 'block',
                                        aspectRatio: '1/1' // Ensures perfect circle
                                      }} 
                                    />
                                  </Box>
                                ))}
                              </Box>
                              </Box>
                           
                          )}
                      {
                        selectedAvatar && (
                        

                      <div>

                          
                      {/* Disability Yes/No Field */}
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel id="disability-radio-group">Do you have a disability?</FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="disability-radio-group"
                          name="disability-radio-buttons-group"
                          value={hasDisability}
                          onChange={(e) => setHasDisability(e.target.value)}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                          <FormControlLabel value="prefer-not-to-say" control={<Radio />} label="Prefer not to say" />
                        </RadioGroup>
                      </FormControl>

                      {/* Show disability categories if user selected "yes" */}
                      {hasDisability === "yes" && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel>Disability Category</InputLabel>
                          <Select
                            value={disability_type}
                            label="Disability Category"
                            onChange={(e) => setDisabilityType(e.target.value)}
                          >
                            <MenuItem value="sensory">Sensory disability</MenuItem>
                            <MenuItem value="neurological">Neurological disability</MenuItem>
                            <MenuItem value="intellectual">Intellectual disability</MenuItem>
                            <MenuItem value="mental-health">Mental health condition</MenuItem>
                            <MenuItem value="physical">Physical disability</MenuItem>
                            <MenuItem value="other">Other</MenuItem>
                          </Select>
                        </FormControl>
                      )}

                      {/* Show specific sensory options if user selected "sensory" */}
                      {hasDisability === "yes" && disability_type === "sensory" && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel>Sensory Disability Type</InputLabel>
                          <Select
                            value={disability}
                            label="Sensory Disability Type"
                            onChange={(e) => setDisability(e.target.value)}
                          >
                            {sensoryDisabilityOptions.map((option) => (
                              <MenuItem 
                                key={option} 
                                value={option}
                                sx={{
                                  whiteSpace: 'normal',
                                  py: 1.5
                                }}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {/* Similar pattern for other disability categories */}
                      {hasDisability === "yes" && disability_type === "neurological" && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel>Neurological Disability Type</InputLabel>
                          <Select
                            value={disability}
                            label="Neurological Disability Type"
                            onChange={(e) => setDisability(e.target.value)}
                          >
                            {neurologicalDisabilityOptions.map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {/* Repeat for other disability categories */}

                      {hasDisability === "yes" && disability_type === "physical" && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel>Physical Disability Type</InputLabel>
                          <Select
                            value={disability}
                            label="Physical Disability Type"
                            onChange={(e) => setDisability(e.target.value)}
                          >
                            {physicalDisabilityOptions.map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {hasDisability === "yes" && disability_type === "mental-health" && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel>Mental Health Condition Type</InputLabel>
                          <Select
                            value={disability}
                            label="Mental Health Condition Type"
                            onChange={(e) => setDisability(e.target.value)}
                          >
                            {mentalHealthConditionOptions.map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {hasDisability === "yes" && disability_type === "intellectual" && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel>Intellectual Disability Type</InputLabel>
                          <Select
                            value={disability}
                            label="Intellectual Disability Type"
                            onChange={(e) => setDisability(e.target.value)}
                          >
                            {intellectualDisabilityOptions.map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                      </div>
                        )}
                      </>
                    )}

                    <TextField
                      fullWidth
                      label="Username"
                      variant="outlined"
                      margin="normal"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                    <TextField
                      fullWidth
                      label="Password"
                      type="password"
                      variant="outlined"
                      margin="normal"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <Typography
                      align="right"
                      sx={{ mt: 1, fontSize: "14px" }}
                    >
                      <Link to="/forgotpassword" style={{ color: "#1e3a8a", textDecoration: "none" }}>
                        Forgot Password?
                      </Link>
                    </Typography>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      sx={{
                        mt: 2,
                        backgroundColor: "#1e3a8a",
                        "&:hover": { backgroundColor: "#214096ff" },
                      }}
                    >
                      {activeTab === "login" ? "Login" : "Register"}
                    </Button>
                    {error && (
                      <Typography color="error" align="center" sx={{ mt: 2 }}>
                        {error}
                      </Typography>
                    )}
                  </form>
                </Paper>
              </Box>
              {/* Snackbar for feedback */}
                <Snackbar
                  open={openSnackbar}
                  autoHideDuration={6000}
                  onClose={() => setOpenSnackbar(false)}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <Alert onClose={() => setOpenSnackbar(false)} severity={severity}>
                    {message}
                  </Alert>
                </Snackbar>
                        </div>
            </div>
  );
};
export const getToken = () => {
    return Cookies.get("accessToken");
};
export const getRefreshToken = () => {
  return Cookies.get("refreshToken");
};
export const getUsername = () => {
  return Cookies.get("username");
};
export const getUserId = () => {
  return Cookies.get("userId");
};
export default Auth;